import { themeConfig } from 'theme/theme-config';

import type { SettingsState } from './types';

export const SETTINGS_STORAGE_KEY_APP_INFORCFC = 'app-settings-app-inforcfc';

export const defaultSettingsAppInforcfc: SettingsState = {
  colorScheme: 'light',
  direction: themeConfig.direction,
  contrast: 'default',
  navLayout: 'vertical',
  primaryColor: 'preset3',
  navColor: 'apparent',
  compactLayout: true,
  fontSize: 16,
  fontFamily: themeConfig.fontFamily.primary,
};
